import React, { useState, useEffect } from "react";
import {
  Box,
  IconButton,
  Avatar,
  Text,
  Flex,
  Button,
  VStack,
  useColorModeValue,
  Spacer,
} from "@chakra-ui/react";
import {
  CheckIcon,
  ArrowBackIcon,
} from "@chakra-ui/icons";
import { FaRedo } from "react-icons/fa";
import { getBid, cqAPI } from "../../lib/Auth";
import { useNavigate } from "react-router-dom";

function IntercomInfo({
  setConversationClosed,
  userInfo,
  conversationClosed,
  messages,
  addActionBarItem,
  relatedUid,
  removeActionBarItem,
  isMobile,
}) {
  const bid = getBid();
  const navigate = useNavigate();
  const userInfoTopBoxBG = useColorModeValue('#D8DEDF', '#303343');
  const [showUserInfo, setShowUserInfo] = useState(!isMobile);
  const [onlineStatus, setOnlineStatus] = useState(false);

  useEffect(() => {
    setShowUserInfo(!isMobile);
  }, [isMobile])

  useEffect(() => {
    const getOnlineStatus = async () => {
      if (!userInfo.user_id){
        return;
      }
      const response = await cqAPI.get(`/a-dec/status/`,{user_id: userInfo.user_id});
      if (response.status ==='ok'){
        setOnlineStatus(response.data.online);
      }
    };

    getOnlineStatus();
  }, [userInfo.user_id])


  useEffect(() => {
    const itemsToAdd = [
      {
        id: "avatar",
        component: (
          relatedUid? <Box position="relative" style={{ marginLeft: "40px" }}>
              <Avatar size="sm" src={userInfo.pic} />
              <IconButton
                icon={
                  <Box
                    mr={2}
                    bg={onlineStatus ? 'green' : "grey"}
                    w="8px"
                    h="8px"
                    borderRadius="full"
                    display="inline-block"
                  />
                }
                variant="none"
                position="absolute"
                top="1"
                right="0"
                transform="translate(50%, -50%)"
              />
          </Box> : <></>
        ),
        align: "left",
      },
      {
        id: "profile-name",
        component: (
          <Text className="profile-name" style={{ fontWeight: "600" }}>
            {userInfo?.name}
          </Text>
        ),
        align: "left",
      },
      {
        id: "conversation-status",
        component: (
          <IconButton
            icon={conversationClosed ? <FaRedo/> : <CheckIcon/>}
            size="sm"
            variant="ghost"
            onClick={toggleConversationStatus}
            _hover={{ bg: "transparent" }}
            _active={{ bg: "transparent" }}
            _focus={{ boxShadow: "none" }}
          />
        ),
        align: "right",
      },
    ];
    itemsToAdd.forEach(addActionBarItem);

    return () => {
      itemsToAdd.forEach((item) => removeActionBarItem(item.id));
    };
  }, [userInfo, conversationClosed]);


  const onClose = () => {
    const path = window.location.pathname.startsWith('/intercom')? "intercom" : "team"
    navigate(`/${path}?bid=${bid}`);
  };

  const toggleConversationStatus = async () => {
    const lastMessage = messages.findLast((x) => x._id && !x.call_id)
    if (!lastMessage){
      return
    }
    const response = await cqAPI.put("/messages", {
      closed: !conversationClosed,
      _id: lastMessage._id.split(':')[0],
    });
    if (response.type === "ok") {
      setConversationClosed(!conversationClosed);
    }
  };

  return (
    showUserInfo && (
        <Box bg={userInfoTopBoxBG} p={1}  direction="column" width="100%" borderRadius="12px 12px 0px 0px">
          <Flex justify="flex-start" alignItems="center">
            <Button variant="backButtonInbox" leftIcon={<ArrowBackIcon/>} onClick={onClose}/>
            {relatedUid &&
              <Box position="relative" >
                <Avatar size="lg" src={userInfo.pic} my={2} />
                <Box
                  position="absolute"
                  bg={onlineStatus ? 'green' : "grey"}
                  top="2"
                  right="1"
                  boxSize="3"
                  borderRadius="full"
                />
              </Box>
            }
            <VStack spacing={1} pl={2} alignItems="left" width="70%">
              <Flex align="center" className="intercom-name-info">
                <Text> {userInfo.name} </Text>
              </Flex>

              {relatedUid &&
                <Flex align="center" className="intercom-email-info">
                  <Text> {userInfo.email} </Text>
                </Flex>
              }
            </VStack>
            <Spacer/>
            <Flex width="150px" ml={2} mr={6}>
              <Button
                leftIcon={conversationClosed ? <FaRedo/> : <CheckIcon/>}
                size="sm"
                variant="solid"
                onClick={toggleConversationStatus}
              >
                {(conversationClosed ? "Open " : "Close ") +
                  (window.location.pathname.startsWith('/intercom')? "intercom" : "chat")
                }
              </Button>
            </Flex>
          </Flex>
        </Box>
    )
  )
}

export default IntercomInfo;
